import React from 'react';
import Navigation from './Navigation';

const Layout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-stone-50">
      {/* Navigation — sidebar on desktop, bottom tab bar on mobile (visibility handled inside component) */}
      <Navigation />

      {/* Main content — extra bottom padding on mobile so content clears the bottom nav */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 flex flex-col overflow-hidden bg-stone-100 pb-16 md:pb-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
